import {
  SET_TOOL_DETAIL,
  SET_ACTIVES,
  SET_IMAGES,
  DELETE_IMAGE,
  REPLACE_ACTIVES,
  CLEAR_ALL,
  INIT_LOCAL,
  SET_EDIT_TOOL,
} from "./types";
import {
  toolDetailMap,
  toolActivesMap,
  toolImagesMap,
  toolItemMap,
  tools,
} from "@/settings/processImage";
import { setItem, removeItem, getItem } from "@/common/storage";
import cloneDeep from "lodash/cloneDeep";

const getIndexOf = (arr, id, field) => {
  let idx = -1;
  if (!arr.length) return -1;
  arr.map((_i, index) => {
    if (arr[index][field] === id) {
      idx = index;
    }
  });
  return idx;
};

export default {
  [SET_TOOL_DETAIL](state, config) {
    const item = config.item;
    const fileId = item.fileId;
    const cache = item.cache || null;
    const curToolDetail = toolDetailMap.get(item.tool);

    const isInclude = Object.keys(state[curToolDetail]).includes(fileId);
    let _data = isInclude ? state[curToolDetail][fileId] : {};
    const res = Object.assign(_data, config.item);

    state[curToolDetail][fileId] = res;
    state[curToolDetail].loading = config.loading || false;
    if (cache) state[curToolDetail].cache = cache;

    if (![tools.ImageCompressor, tools.ImagerConverter].includes(config.tool)) {
      state[curToolDetail].downloadHD = config.downloadHD || false;
      state[curToolDetail].downloadFHD = config.downloadFHD || false;
      state[curToolDetail].showHuge = config.showHuge || false;
    } else {
      state[curToolDetail][fileId].loading = item.loading || false;
    }

    setItem(curToolDetail, state[curToolDetail]);
  },

  [SET_ACTIVES](state, config) {
    const curActives = toolActivesMap.get(config.tool);
    if (!state[curActives]) {
      state[curActives] = [];
    }
    const idx = state[curActives].indexOf(config.fileId);
    if (idx !== -1) {
      state[curActives].splice(idx, 1);
    } else {
      state[curActives].unshift(config.fileId);
    }
    setItem(curActives, state[curActives]);
  },

  [SET_IMAGES](state, config) {
    const curImages = toolImagesMap.get(config.tool);
    if (!state[curImages]) {
      state[curImages] = [];
    }
    if (!state[curImages].length) {
      state[curImages].unshift({ ...config });
    } else {
      const idx = getIndexOf(state[curImages], config.fileId, "fileId");
      if (idx !== -1) {
        const res = Object.assign(state[curImages][idx], config);
        state[curImages][idx] = res;
      } else {
        state[curImages].unshift({ ...config });
      }
    }
    setItem(curImages, state[curImages]);
  },

  [DELETE_IMAGE](state, config) {
    const curToolDetail = toolDetailMap.get(config.tool);
    const curImages = toolImagesMap.get(config.tool);
    state[curToolDetail] = {};
    removeItem(curToolDetail);
    const iIdx = getIndexOf(state[curImages], config.fileId, "fileId");
    delete state[curToolDetail][config.fileId];
    const arr = Object.keys(state[curToolDetail]);
    if (arr.length === 1 && arr[0] === "loading") {
      state[curToolDetail] = {};
    }
    if (![tools.ImageCompressor, tools.ImagerConverter].includes(config.tool)) {
      const curActives = toolActivesMap.get(config.tool);
      const aIdx = state[curActives].indexOf(config.fileId);
      if (aIdx !== -1) state[curActives].splice(aIdx, 1);
      setItem(curActives, state[curActives]);
    }
    if (iIdx !== -1) state[curImages].splice(iIdx, 1);
    setItem(curToolDetail, state[curToolDetail]);
    setItem(curImages, state[curImages]);
  },

  [REPLACE_ACTIVES](state, config) {
    const curActives = toolActivesMap.get(config.tool);
    state[curActives] = config.actives;
    setItem(curActives, state[curActives]);
  },

  [CLEAR_ALL](state, config) {
    const curToolDetail = toolDetailMap.get(config.tool);
    const curImages = toolImagesMap.get(config.tool);
    const curActives = toolActivesMap.get(config.tool);
    state[curToolDetail] = {};
    state[curActives] = [];
    state[curImages] = [];
    removeItem(curToolDetail);
    removeItem(curActives);
    removeItem(curImages);
  },

  [INIT_LOCAL](state, config) {
    const curToolDetail = toolDetailMap.get(config.tool);
    const curImages = toolImagesMap.get(config.tool);
    state[curToolDetail] = getItem(curToolDetail) || {};
    state[curToolDetail].loading = false;
    state[curImages] = getItem(curImages) || [];
    if (![tools.ImageCompressor, tools.ImagerConverter].includes(config.tool)) {
      const curActives = toolActivesMap.get(config.tool);
      state[curActives] = getItem(curActives) || [];
    }
  },

  SET_LARGE_ITEM(state, object) {
    state.bgLargeItem = object;
  },

  SET_ITEM(state, { tool, config }) {
    state[toolItemMap.get(tool)] = config;
  },

  SET_RESIZE_ITEM(state, object) {
    state.resizeItem = object;
  },

  SET_SIGN_CACHE(state, object) {
    state.signCache = object;
  },

  SET_DOWNLOAD_SIGN_CACHE(state, object) {
    state.downloadSignCache = object;
  },

  [SET_EDIT_TOOL](state, config) {
    const tempStat = cloneDeep(config);
    const { tool } = config;
    const opreation = config.opreation || "save";

    const init = (currDetail, stat) => {
      if (!currDetail) {
        state[tool] = {
          tool,
          fileList: stat?.fileList || [],
          configuration: stat.configuration || {},
        };
      }
    };

    const saveFile = (currDetail, stat) => {
      const { fileList } = currDetail || {};
      const { fileList: list } = stat;
      for (let i = 0; i < list.length; i++) {
        const { fileId } = list[i];
        const idx = getIndexOf(fileList || [], fileId, "fileId");
        if (idx !== -1) {
          state[tool].fileList[idx] = list[i];
        } else {
          state[tool].fileList.unshift(list[i]);
        }
      }
    };

    const updateFile = (stat) => {
      state[tool].fileList = stat.fileList;
    };

    const deleteStat = (tool) => {
      state[tool] = null;
    };

    const updateStat = (stat) => {
      const configuration = Object.assign(state[tool].configuration, {
        ...(stat.configuration || {}),
      });
      state[tool].configuration = configuration;
    };

    switch (opreation) {
      case "init":
        init(state[tool], tempStat);
        break;
      case "save":
        saveFile(state[tool], tempStat);
        break;
      case "update":
        updateFile(tempStat);
        break;
      case "delete":
        deleteStat(tool);
        break;
    }

    if (opreation !== "delete" && state[tool]) {
      updateStat(tempStat);
    }
  },
};
